import { Link } from "react-router-dom";
import BetaLayout from "./BetaLayout";

export default function BetaIntro() {
  return (
    <BetaLayout>
      <article className="beta-card">
        <p className="beta-kicker">DreamHomeJourney.online</p>
        <h1>Welcome to the REChecklist Beta Tester Program</h1>
        <p>
          You’ve been personally selected to help shape the future of real estate workflow. Thank
          you for agreeing to test our system, use it free of charge, and provide honest feedback.
        </p>
        <p>
          This is your early-access version of REChecklist — a tool designed to make your real
          estate business smoother, clearer, and more enjoyable. We want you to feel empowered, not
          lost, and to use this system as if it is already yours.
        </p>
        <p className="beta-note">
          Opening REChecklist from the public site does not start this program. Only the custom
          link given directly to you activates Beta access. You’re in the right place if you are
          starting from that link.
        </p>
        <p>
          We believe REChecklist is exactly what the real estate industry needed yesterday. Please
          explore freely, enter real client information, and enjoy the experience. Your feedback
          will help us refine this into a hands-down, grounded success — a pleasure to use, and
          your new real estate business wonder-tool.
        </p>
        <p>
          Please don’t hesitate to reach out to{" "}
          <a href="mailto:sysadmin@rechecklist.pro">sysadmin@rechecklist.pro</a> if you have any
          questions.
        </p>
        <div className="beta-actions">
          <Link className="btn" to="/beta/agreement">
            Begin Beta Access
          </Link>
        </div>
      </article>
    </BetaLayout>
  );
}
